// services/commandsApi.js
// Catalog for the "/" command palette. The backend already hides commands the user may not run.
const apiUrl = process.env.VUE_APP_API_URL

// GET /commands -> { isAdmin, commands: [{ id, label, description, category, adminOnly }] }
export async function getCommands(apiKey) {
  const res = await fetch(`${apiUrl}/commands`, {
    headers: { 'Content-Type': 'application/json', 'apiKey': apiKey }
  })
  if (!res.ok) throw new Error(`getCommands failed: ${res.status}`)
  return res.json()
}
